import React from 'react';
import PropTypes from 'prop-types';
import NavBarItem from './NavBarItem';
import {Message} from '@aperza/ui';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class MarketplaceBar extends React.Component {

  render() {

    return (
      <div className="marketplace-bar-item">
        <div className="marketplace-bar-item-content">
          <Message messageId="navbar.searchCatalog" />
        </div>
        <div className="marketplace-bar-item-bg">
        </div>
      </div>
    )
  }

}
